import { useMutation } from '@tanstack/react-query';
import httpClient, { ApiResponse } from '../httpClient';
import { API_ENDPOINTS } from '../endpoints';
import { TradingCalculation } from '../types';

export interface CrmCalculateParams {
    instrument_id: string;
    lot_size: number;
    leverage: number;
    price?: number;
    entry_price?: number;
    current_price?: number;
    side?: 'buy' | 'sell';
    target_pnl?: number;
}

const calculateTrade = async (params: CrmCalculateParams): Promise<TradingCalculation> => {
    const { data } = await httpClient.post<ApiResponse<TradingCalculation>>(
        API_ENDPOINTS.CRM.INSTRUMENTS_CALCULATE(params.instrument_id),
        {
            lot_size: params.lot_size,
            leverage: params.leverage,
            price: params.price,
            entry_price: params.entry_price,
            current_price: params.current_price,
            side: params.side,
            target_pnl: params.target_pnl,
        }
    );
    return data.data;
};

export const useCrmCalculateTrade = () => {
    return useMutation<TradingCalculation, Error, CrmCalculateParams>({
        mutationFn: calculateTrade,
    });
};
